/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu'
import { LinqService, QueryOptions } from 'linquest'
import { PerformanceFormPeriodDto, PerformanceFormEvaluationStartResultViewModel } from './models'

/**
 * PerformanceFormPeriodApi - API class
 */
export class PerformanceFormPeriodApi extends LinqService {
  /**
   * Creates a new PerformanceFormPeriodApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider)
  }

  /**
   * @param dto
   */
  addOrUpdateAsync(dto?: PerformanceFormPeriodDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriod/AddOrUpdateAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriod/DeleteAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriod/GetAsync`
    let query = this.createQuery<PerformanceFormPeriodDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param id
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriod/GetTranslatedAsync`
    let query = this.createQuery<PerformanceFormPeriodDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() })
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param performanceFormIds
   */
  goBackToContinuousPerformancePeriodAsync(performanceFormIds?: Array<string>, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriod/GoBackToContinuousPerformancePeriodAsync`
    let query = this.createQuery<PerformanceFormEvaluationStartResultViewModel>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = performanceFormIds
    query = query.withOptions(options)

    return query
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriod/List`
    let query = this.createQuery<PerformanceFormPeriodDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriod/ListTranslated`
    let query = this.createQuery<PerformanceFormPeriodDto>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'GET'
    options.params = options.params || []
    options.headers = options.headers || {}

    query = query.withOptions(options)

    return query
  }

  /**
   * @param dto
   */
  saveAsync(dto?: PerformanceFormPeriodDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriod/SaveAsync`
    let query = this.createQuery<any>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = dto
    query = query.withOptions(options)

    return query.firstAsync()
  }

  /**
   * @param performanceFormIds
   */
  startPerformanceFormEvaluationPeriodJobAsync(performanceFormIds?: Array<string>, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormPeriod/StartPerformanceFormEvaluationPeriodJobAsync`
    let query = this.createQuery<boolean>(url)

    // initialize options
    options = options || {}
    options.method = options.method || 'POST'
    options.params = options.params || []
    options.headers = options.headers || {}

    // set body parameter
    options.data = performanceFormIds
    query = query.withOptions(options)

    return query.firstAsync()
  }
}
